module.exports = __webpack_public_path__ + "img/section_community_image.ea3a0614.jpg";